import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};
export const API_CREATE_CATAGORY = async (data) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.post(
      "/category/create-category",
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_LIST_CATAGORY = async (params) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get(
      "/category/categories",
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
        params: params, // Include dynamic params
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_DELETE_CATAGORY = async (id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.delete(
      `/category/category/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_GET_CATAGORY = async (id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get(
      `/category/category/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};



export const API_UPDATE_CATAGORY = async (data, id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.put(
      `/category/category/${id}`,
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
